import * as React from "react";
import type { SVGProps } from "react";

const SvgCircleBellWithBubbleIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
        <g
            id="Group_10077"
            data-name="Group 10077"
            transform="translate(0.299)"
        >
            <circle
                id="Ellipse_420"
                data-name="Ellipse 420"
                cx="16"
                cy="16"
                r="16"
                transform="translate(-0.299)"
                fill="currentColor"
            />
            <path
                id="Icon_material-notifications"
                data-name="Icon material-notifications"
                d="M14,23.25a2.006,2.006,0,0,0,2-2H12A2,2,0,0,0,14,23.25Zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V5.25a1.5,1.5,0,1,0-3,0v.68C9.63,6.61,8,9.17,8,12.25v5l-2,2v1H22v-1Z"
                transform="translate(1.696 2.5)"
                fill="#fff"
            />
            <g
                id="Ellipse_446"
                data-name="Ellipse 446"
                transform="translate(15.701 6)"
                fill="#e22922"
                stroke="#fff"
                strokeWidth="1"
            >
                <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                <circle cx="4.5" cy="4.5" r="4" fill="none" />
            </g>
        </g>
    </svg>
);
export default SvgCircleBellWithBubbleIcon;
